<template>
  <v-layout
    class="
      primary
      fill-height
      overflow-x-hidden
      textured-wrapper
      pt-0
      d-flex
      flex-column
    "
    :style="{
      backgroundImage: `url('${textureImage}')`,
      width: '100vw',
      height: '100vh',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
    }"
  >
    <v-container>
      <v-row justify="center" class="onboarding-wrapper mb-16">
        <v-col cols="12">
          <div
            class="secondary--text text-h2 font-weight-bold text-center py-16"
            :class="{ 'text-h4 mt-0': $vuetify.breakpoint.mdAndDown }"
          >
            Take The First Step To Luxury
          </div>

          <v-row
            class="mb-5"
            :class="{ 'my-16': $vuetify.breakpoint.mdAndUp }"
            justify="space-around"
            align="center"
          >
            <v-col cols="12" md="4" v-for="(option, i) in options" :key="i">
              <div class="d-flex justify-center">
                <v-card
                  @click="select(i)"
                  tile
                  class="
                    d-flex
                    flex-column
                    align-center
                    justify-center
                    pa-8
                    cursor-pointer
                  "
                  flat
                  width="300px"
                  height="260px"
                >
                  <hm-icon
                    width="48"
                    height="48"
                    scale="1.8"
                    :icon-color="
                      selected == i
                        ? $vuetify.theme.themes.light.secondary
                        : $vuetify.theme.themes.light.primary
                    "
                  >
                    <component :is="option.icon" />
                  </hm-icon>

                  <div
                    class="text-h5 text-center mt-5 mx-5"
                    :class="{
                      'secondary--text': selected == i,
                      'primary--text': selected != i,
                      'text-h5': $vuetify.breakpoint.mdAndDown,
                    }"
                  >
                    {{ option.title }}
                  </div>
                </v-card>
              </div>
            </v-col>
          </v-row>

          <div class="d-flex justify-center">
            <v-btn
              @click="proceed"
              tile
              depressed
              class="text-none py-7"
              color="secondary"
            >
              <span class="mr-2 white--text text-h6">Continue</span>
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-card
      class="mt-auto"
      height="15vh"
      color="transparent"
      v-if="$vuetify.breakpoint.mdAndUp"
      width="100%"
      :style="{
        backgroundImage: `url('${baseImage}')`,
        width: '100vw',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center bottom',
        opacity: '0.81',
      }"
    ></v-card>
  </v-layout>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import InvestmentIcon from "@/components/icons/InvestmentIcon.vue";
import HomesIcon from "@/components/icons/HomesIcon.vue";
import LandbankIcon from "@/components/icons/LandbankIcon.vue";
import HmIcon from "@/components/HmIcon.vue";

export default {
  components: {
    Navbar,
    InvestmentIcon,
    LandbankIcon,
    HomesIcon,
    HmIcon,
  },
  data() {
    return {
      baseImage: require("@/assets/svg/hm-base.png"),
      textureImage: require("@/assets/green-texture.png"),
      selected: null,
      options: [
        {
          icon: "homes-icon",
          title: "Purchase A House",
          route: "onboarding.location",
          query: { type: "homes" },
        },
        {
          icon: "landbank-icon",
          title: "Buy A Landbank",
          route: "onboarding.location",
          query: { type: "landbank" },
        },
        {
          icon: "investment-icon",
          title: "Make An Investment",
          route: "onboarding.investments",
          query: {},
        },
      ],
    };
  },
  methods: {
    select(index) {
      if (this.selected == index) return (this.selected = null);
      this.selected = index;

      if (this.$vuetify.breakpoint.mdAndDown) {
        this.proceed();
      }
    },
    goToPage(name, query) {
      this.$router.push({ name, query });
    },
    proceed() {
      if (this.selected !== null) {
        this.goToPage(
          this.options[this.selected].route,
          this.options[this.selected].query
        );
        return;
      }
      this.$store.commit("openSnackbar", "You have to select a journey");
    },
  },
};
</script>

<style lang="scss" scoped>
.textured-wrapper {
  height: calc(100vh - 200px);
}
</style>
